import {isInLabelValueArrayAsString, isValidDateTimeString, isValidPositiveNumber} from "@utils/validators";
import {
   CONVICTION_CODES,
   conviction_PARTIES_AT_FAULT_OPTIONS,
   conviction_TYPE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {objValueAsArray, objValueAsString} from "@utils/object";
import {isDateGreaterThenToday} from "@utils/date-time";
import {isNotStringOrEmptyString} from "@utils/string";

export const validateCommonPolicyHolderConvictions = ({
   data,
   msgList,
}) => {
   
   if (!isInLabelValueArrayAsString(data.hasMotoringConvictionsInLast5Years, YES_NO_CHOICE_OPTIONS)) {
      
      msgList.push({
         name: 'hasMotoringConvictionsInLast5Years',
         message: `Please choose if you have motoring convictions in the last 5 years`
      });
      
      return;
      
   }
   
   data.hasMotoringConvictionsInLast5Years = objValueAsString(data,'hasMotoringConvictionsInLast5Years');
   
   if ('No' === data.hasMotoringConvictionsInLast5Years) {
      return;
   }
   
   let motorConvictionsList = objValueAsArray(data, 'motorConvictionsList');
   
   if (motorConvictionsList.length === 0) {
      msgList.push({
         name: 'motorConvictionsList',
         message: `Please add at least one conviction record`
      });
      
      return;
   }
   
   motorConvictionsList.forEach((conviction, convictionIndex) => {
      
      validateConviction({
         conviction,
         convictionIndex,
         msgList
      })
      
   })
   
};

const validateConviction = ({conviction, convictionIndex, msgList}) => {
   
   /**
    * Date of conviction
    */
   
   if(!isValidDateTimeString(conviction.date)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.date`,
         message: `Please specify the date of conviction @ conviction form ${convictionIndex + 1}`
      });
   } else if(isDateGreaterThenToday(conviction.date)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.date`,
         message: `The date of conviction cannot be in the future @ conviction form ${convictionIndex + 1}`
      });
   }
   
   /**
    * Code
    */
   
   if(!isInLabelValueArrayAsString(conviction.code,CONVICTION_CODES)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.code`,
         message: `Please specify the conviction code @ conviction form ${convictionIndex + 1}`
      });
   }

   if(isNotStringOrEmptyString(conviction.points)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.points`,
         message: `Please specify the conviction points @ conviction form ${convictionIndex + 1}`
      });
   } else if(!isValidPositiveNumber(conviction.points)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.points`,
         message: `The conviction points must be a positive number @ conviction form ${convictionIndex + 1}`
      });
   }
   
   if(isNotStringOrEmptyString(conviction.fines)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.fines`,
         message: `Please specify the conviction fines @ conviction form ${convictionIndex + 1}`
      });
   } else if(!isValidPositiveNumber(conviction.fines,true)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.fines`,
         message: `The conviction fines must be a positive number or 0 @ conviction form ${convictionIndex + 1}`
      });
   }
   
   if(isNotStringOrEmptyString(conviction.banLengthInMonths)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.banLengthInMonths`,
         message: `Please specify the conviction ban length in months @ conviction form ${convictionIndex + 1}`
      });
   } else if(!isValidPositiveNumber(conviction.banLengthInMonths)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.banLengthInMonths`,
         message: `The conviction ban length in months must be a positive number or 0 @ conviction form ${convictionIndex + 1}`
      });
   }
   
   if(!isInLabelValueArrayAsString(conviction.wasDriverBreathalysed,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.wasDriverBreathalysed`,
         message: `Please specify if the driver was breathalysed @ conviction form ${convictionIndex + 1}`
      });
   }
   
   if(!isInLabelValueArrayAsString(conviction.wasOffenceAccidentRelated,YES_NO_CHOICE_OPTIONS)) {
      msgList.push({
         name: `motorConvictionsList.${convictionIndex}.wasOffenceAccidentRelated`,
         message: `Please specify if the offence was accident related @ conviction form ${convictionIndex + 1}`
      });
   }
};
